(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rareagave-bottle-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ra-bottle-finder')) {
    class RaBottleFinder extends HTMLElement {
      connectedCallback() {
        this.answers = {};
        this.bottleMatrix = [
          { h:'arette-tequila-blanco-750ml', q:81, e:1, p:'bright', b:'under-50', u:['cocktails','explore'] },
          { h:'cimarron-tequila-blanco-750ml', q:84, e:1, p:'bright', b:'under-50', u:['cocktails'] },
          { h:'calle-23-tequila-blanco-750ml', q:82, e:1, p:'bright', b:'under-50', u:['cocktails'] },
          { h:'tequila-ocho-plata-750ml', q:88, e:1, p:'bright', b:'under-50', u:['sip','explore','gift'] },
          { h:'g4-tequila-blanco-750ml', q:88, e:3, p:'bright', b:'under-50', u:['sip','explore','gift'] },
          { h:'tapatio-tequila-blanco-80pf-750ml', q:87, e:2, p:'bright', b:'under-50', u:['cocktails','sip'] },
          { h:'arette-tequila-reposado-750ml', q:81, e:1, p:'smooth', b:'under-50', u:['cocktails','sip'] },
          { h:'calle-23-tequila-reposado-750ml', q:82, e:1, p:'smooth', b:'under-50', u:['sip'] },
          { h:'suerte-tequila-anejo-750ml', q:84, e:1, p:'rich', b:'under-50', u:['sip','gift'] },
          { h:'don-fulano-tequila-blanco-750ml', q:88, e:2, p:'bright', b:'50-80', u:['sip','cocktails','explore','gift'] },
          { h:'el-tesoro-tequila-blanco-750ml', q:87, e:1, p:'bright', b:'50-80', u:['sip','cocktails','explore','gift'] },
          { h:'g4-tequila-reposado-allocated-750ml', q:88, e:1, p:'smooth', b:'50-80', u:['sip','gift'] },
          { h:'tequila-ocho-reposado-2024-750ml', q:87, e:1, p:'smooth', b:'50-80', u:['sip','cocktails','explore','gift'] },
          { h:'tequila-ocho-anejo-2024-750ml', q:88, e:1, p:'rich', b:'50-80', u:['sip','gift'] },
          { h:'wild-common-tequila-blanco-750ml', q:90, e:2, p:'bright', b:'50-80', u:['sip','cocktails','explore'] },
          { h:'wild-common-tequila-reposado-750ml', q:89, e:2, p:'smooth', b:'50-80', u:['sip','cocktails','gift'] },
          { h:'volans-tequila-blanco-750ml', q:89, e:3, p:'bright', b:'50-80', u:['sip','explore'] },
          { h:'volans-tequila-reposado-750ml', q:88, e:3, p:'smooth', b:'50-80', u:['sip','gift'] },
          { h:'artenom-1579-tequila-blanco-750ml', q:88, e:3, p:'bright', b:'50-80', u:['sip','explore'] },
          { h:'artenom-1123-tequila-blanco-750ml', q:89, e:3, p:'bright', b:'50-80', u:['sip','explore'] },
          { h:'artenom-1414-tequila-reposado-750ml', q:88, e:3, p:'smooth', b:'50-80', u:['sip','gift'] },
          { h:'tapatio-tequila-anejo-750ml', q:88, e:3, p:'rich', b:'50-80', u:['sip','gift'] },
          { h:'lagrimas-tequila-reposado-la-sabino-750ml', q:89, e:3, p:'smooth', b:'50-80', u:['sip','explore'] },
          { h:'tequila-general-gorostieta-blanco-750ml', q:88, e:2, p:'bright', b:'50-80', u:['sip','explore','gift'] },
          { h:'g4-tequila-blanco-de-madera-750ml', q:92, e:3, p:'bold', b:'50-80', u:['sip','cocktails','explore'] },
          { h:'santo-tequila-blanco-110-750ml', q:86, e:1, p:'bold', b:'50-80', u:['sip','cocktails','explore'] },
          { h:'siembra-azul-tequila-blanco-750ml', q:88, e:2, p:'bright', b:'50-80', u:['sip','explore'] },
          { h:'cascahuin-tequila-tahona-750ml', q:91, e:2, p:'bright', b:'80-125', u:['sip','explore','gift'] },
          { h:'cascahuin-tequila-plata-48-750ml', q:90, e:3, p:'bold', b:'80-125', u:['sip','explore'] },
          { h:'cazcanes-tequila-blanco-still-strength-750ml', q:88, e:2, p:'bold', b:'80-125', u:['sip','explore','gift'] },
          { h:'cazcanes-tequila-reposado-750ml', q:86, e:1, p:'smooth', b:'80-125', u:['sip','gift'] },
          { h:'wild-common-tequila-still-strength-blanco-750ml', q:91, e:3, p:'bold', b:'80-125', u:['sip','explore','gift'] },
          { h:'volans-tequila-still-strength-750ml', q:91, e:3, p:'bold', b:'80-125', u:['sip','explore'] },
          { h:'siembra-alteno-reposado-tequila-750ml', q:89, e:2, p:'smooth', b:'80-125', u:['sip','explore','gift'] },
          { h:'artenom-1146-tequila-anejo-750ml', q:89, e:2, p:'rich', b:'80-125', u:['sip','gift'] },
          { h:'lost-lore-tequila-anejo-750ml', q:88, e:1, p:'rich', b:'80-125', u:['sip','gift'] },
          { h:'cazcanes-tequila-anejo-750ml', q:87, e:1, p:'rich', b:'125-plus', u:['sip','gift'] },
          { h:'el-tesoro-tequila-anejo-yamazaki-750ml', q:89, e:2, p:'rich', b:'125-plus', u:['sip','gift'] },
          { h:'el-tesoro-extra-anejo-paradiso-750ml', q:89, e:2, p:'rich', b:'125-plus', u:['sip','gift'] },
          { h:'fuenteseca-tequila-extra-anejo-7-year-750ml', q:91, e:3, p:'rich', b:'125-plus', u:['sip','explore','gift'] }
        ];
        this.steps = [...this.querySelectorAll('.ra-finder__step')];
        this.progress = [...this.querySelectorAll('.ra-finder__progress span')];
        this.result = this.querySelector('.ra-finder__result');
        this.querySelectorAll('[data-answer]').forEach((button) => button.addEventListener('click', () => {
          this.answers[button.dataset.answer] = button.dataset.value;
          const current = Number(button.closest('[data-step]').dataset.step);
          if (current < 3) {
            const next = current + 1;
            if (next === 1) this.updateOptionVisibility('profile');
            if (next === 3) this.updateOptionVisibility('budget');
            this.showStep(next);
          } else {
            this.showResult();
          }
        }));
        this.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => {
          const current = Number(button.closest('[data-step]').dataset.step);
          this.showStep(current - 1);
        }));
        this.querySelector('[data-restart]').addEventListener('click', () => {
          this.answers = {};
          this.result.hidden = true;
          this.showStep(0);
        });
        this.addEventListener('click', async (event) => {
          const addButton = event.target.closest('[data-add-variant]');
          if (!addButton) return;
          addButton.disabled = true;
          addButton.textContent = 'ADDING…';
          try {
            const response = await fetch(this.dataset.rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(addButton.dataset.addVariant), quantity: 1 }] })
            });
            if (!response.ok) throw new Error('Unable to add');
            window.location.href = this.dataset.rootUrl + 'cart';
          } catch (error) {
            addButton.disabled = false;
            addButton.textContent = 'TRY AGAIN';
          }
        });
      }
      updateOptionVisibility(answerType) {
        const purpose = this.answers.purpose;
        const profile = this.answers.profile;
        this.querySelectorAll('[data-answer="' + answerType + '"]').forEach((button) => {
          const value = button.dataset.value;
          const hasChoices = this.bottleMatrix.some((item) => {
            if (!item.u.includes(purpose)) return false;
            if (answerType === 'profile') return item.p === value;
            return item.p === profile && item.b === value;
          });
          button.hidden = !hasChoices;
          button.disabled = !hasChoices;
          button.setAttribute('aria-hidden', String(!hasChoices));
        });
      }
      showStep(index) {
        this.result.hidden = true;
        this.steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
        this.progress.forEach((bar, i) => bar.classList.toggle('is-active', i <= index));
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      escapeHtml(value) {
        const element = document.createElement('div');
        element.textContent = String(value || '');
        return element.innerHTML;
      }
      async showResult() {
        this.steps.forEach((step) => step.classList.remove('is-active'));
        this.progress.forEach((bar) => bar.classList.add('is-active'));
        const profile = this.answers.profile;
        const purpose = this.answers.purpose;
        const experience = this.answers.experience;
        const budget = this.answers.budget;
        const collectionBase = this.dataset.collectionsUrl;
        const bottleMatrix = this.bottleMatrix;
        const routes = {
          bright: ['blanco-tequila', 'Blanco, with the agave in full view', 'Fresh, mineral and expressive—this is where the character of cooked agave speaks most clearly.'],
          smooth: ['reposado-tequila', 'Reposado, balanced between agave and oak', 'A measured rest in barrel adds softness and spice while keeping the spirit’s agave character intact.'],
          rich: ['anejo-tequila', 'Añejo, layered and oak-shaped', 'For deeper texture, mature spice and a richer sipping experience, aged expressions are the natural path.'],
          bold: ['high-proof-still-strength-tequila', 'High proof, with nothing held back', 'Concentrated aroma, texture and agave intensity for drinkers who want a more powerful pour.']
        };
        const choice = routes[profile] || routes.bright;
        const price = {
          'under-50': '?filter.v.price.lte=50',
          '50-80': '?filter.v.price.gte=50&filter.v.price.lte=80',
          '80-125': '?filter.v.price.gte=80&filter.v.price.lte=125',
          '125-plus': '?filter.v.price.gte=125'
        };
        const occasionWhy = {
          sip: 'Built for sipping neat, with enough structure and finish to reward a slower pour.',
          cocktails: 'Expressive enough to remain present in a cocktail without losing its agave character.',
          gift: 'A respected bottle with the quality and presence to feel considered.',
          explore: 'A distinctive bottle that shows more personality than a familiar default.'
        };
        const profileWhy = {
          bright: 'Expect cooked agave, citrus and mineral freshness.',
          smooth: 'Expect rounded texture, gentle oak and balanced spice.',
          rich: 'Expect mature oak, vanilla and deeper baking spice.',
          bold: 'Expect concentrated aroma, texture and higher-proof intensity.'
        };
        const experienceWhy = {
          beginner: 'Approachable without hiding what makes traditional tequila interesting.',
          regular: 'Familiar enough to enjoy immediately, with added character to notice.',
          enthusiast: 'Prioritized for distinctive character, production detail and personality.',
          any: 'The occasion, flavor and budget answers lead the recommendation.'
        };
        this.querySelector('[data-result-title]').textContent = choice[1];
        this.querySelector('[data-result-copy]').textContent = choice[2];
        const fallbackLink = this.querySelector('[data-result-link]');
        const browseLabels = { bright: 'BLANCO', smooth: 'REPOSADO', rich: 'AÑEJO', bold: 'HIGH-PROOF TEQUILA' };
        const budgetLabels = { 'under-50': 'UNDER $50', '50-80': 'FROM $50–$80', '80-125': 'FROM $80–$125', '125-plus': 'FROM $125+' };
        fallbackLink.href = collectionBase + '/' + choice[0] + (price[budget] || '');
        fallbackLink.textContent = 'NOT SEEING THE RIGHT BOTTLE? BROWSE ALL ' + (browseLabels[profile] || 'TEQUILA') + ' ' + (budgetLabels[budget] || '');
        this.result.hidden = false;
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const productGrid = this.querySelector('[data-result-products]');
        productGrid.innerHTML = '<p class="ra-finder__product-loading">Selecting your best available match…</p>';
        const eligible = bottleMatrix.filter((item) => item.b === budget && item.p === profile && item.u.includes(purpose));
        const scoreItem = (item) => {
          let score = item.q || 0;
          const targetExperience = { beginner: 1, regular: 2, enthusiast: 3 }[experience];
          if (targetExperience) {
            const distance = Math.abs((item.e || 2) - targetExperience);
            if (distance === 0) score += 18;
            if (distance === 1) score += 4;
            if (distance === 2) score -= 10;
          }
          if (experience === 'enthusiast' && item.u.includes('explore')) score += 2;
          return score;
        };
        const ranked = eligible
          .filter((item, index, list) => list.findIndex((entry) => entry.h === item.h) === index)
          .map((item, index) => ({ item, index, score: scoreItem(item) }))
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .map((entry) => entry.item);
        const root = this.dataset.rootUrl;
        const products = (await Promise.all(ranked.map(async (item) => {
          try {
            const response = await fetch(root + 'products/' + item.h + '.js');
            if (!response.ok) return null;
            const product = await response.json();
            return product.available ? product : null;
          } catch (error) {
            return null;
          }
        }))).filter(Boolean).slice(0, 3);
        if (!products.length) {
          productGrid.innerHTML = '<p class="ra-finder__product-loading">No exact available bottle matches every answer right now. Browse the full expression below for the closest options.</p>';
          return;
        }

        const primary = products[0];
        const primaryVariant = primary.variants.find((variant) => variant.available) || primary.variants[0];
        const primaryImage = primary.featured_image || '';
        const primaryPrice = new Intl.NumberFormat('en-US', { style:'currency', currency:'USD' }).format(primaryVariant.price / 100);
        const why = [occasionWhy[purpose], profileWhy[profile], experienceWhy[experience]].filter(Boolean);
        const primaryHtml = '<article class="ra-finder__best-match">' +
          '<a class="ra-finder__best-media" href="' + primary.url + '"><img src="' + primaryImage + '&width=720" alt="" loading="lazy"></a>' +
          '<div class="ra-finder__best-copy"><p class="ra-finder__match-label">BEST MATCH</p>' +
          '<h3>' + this.escapeHtml(primary.title) + '</h3><p class="ra-finder__best-price">' + primaryPrice + '</p>' +
          '<h4>Why it fits</h4><ul>' + why.map((reason) => '<li>' + this.escapeHtml(reason) + '</li>').join('') + '</ul>' +
          '<div class="ra-finder__best-actions"><a href="' + primary.url + '">VIEW BOTTLE</a>' +
          '<button type="button" data-add-variant="' + primaryVariant.id + '">ADD TO CART</button></div></div></article>';

        const alternatives = products.slice(1);
        const alternativesHtml = alternatives.length ? '<div class="ra-finder__alternatives"><p class="ra-finder__alternatives-title">ALSO WORTH CONSIDERING</p><div>' +
          alternatives.map((product) => {
            const variant = product.variants.find((item) => item.available) || product.variants[0];
            const image = product.featured_image || '';
            const priceText = new Intl.NumberFormat('en-US', { style:'currency', currency:'USD' }).format(variant.price / 100);
            return '<article class="ra-finder__alternative">' +
              '<a class="ra-finder__alternative-media" href="' + product.url + '"><img src="' + image + '&width=540" alt="" loading="lazy"></a>' +
              '<div><h3>' + this.escapeHtml(product.title) + '</h3><p>' + priceText + '</p>' +
              '<a class="ra-finder__alternative-link" href="' + product.url + '">VIEW BOTTLE</a>' +
              '<button type="button" data-add-variant="' + variant.id + '">ADD</button></div></article>';
          }).join('') + '</div></div>' : '';
        productGrid.innerHTML = primaryHtml + alternativesHtml;
      }
    }
    customElements.define('ra-bottle-finder', RaBottleFinder);
  }

  } catch(e) { console.error(e); }
})();
})();
